import { ShippingOptionDto, ShippingOptionModel } from '../types/shipping-option'
import { transformCurrencyAmountDto } from './currency'

export const transformShippingOptionDto = (
  shippingOption: ShippingOptionDto,
): ShippingOptionModel => ({
  id: shippingOption.id,
  carrierCode: shippingOption.carrier_code,
  carrierIconUrl: shippingOption.carrier_icon_url,
  price: transformCurrencyAmountDto(shippingOption.price),
  discount: shippingOption.discount && {
    percent: shippingOption.discount.percent,
    validFrom: shippingOption.discount.valid_from,
    validTo: shippingOption.discount.valid_to,
    showNote: shippingOption.discount.show_note,
  },
  priceBeforeDiscount:
    shippingOption.price_before_discount &&
    transformCurrencyAmountDto(shippingOption.price_before_discount),
  lowestPriceIn30Days:
    shippingOption.lowest_price_in_30_days &&
    transformCurrencyAmountDto(shippingOption.lowest_price_in_30_days),
  restriction: shippingOption.restriction,
  rateUuid: shippingOption.rate_uuid,
  rootRateUuid: shippingOption.root_rate_uuid,
  title: shippingOption.title,
  valueProposition: shippingOption.value_proposition,
  verificationServiceType: shippingOption.verification_service_type,
  deliveryInDays: shippingOption.delivery_in_days,
})

export const transformShippingOptionDtos = (
  shippingOptions: Array<ShippingOptionDto>,
): Array<ShippingOptionModel> => shippingOptions.map(transformShippingOptionDto)
